import StepperContainer from './styles';

export default StepperContainer;
